module.exports = __webpack_public_path__ + "img/top_bg.88c08551.png";